<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="head-confirm-modal-list">
      <h4>Selecione o Leito que o paciente irá ocupar</h4>
    </div>
    <form class="form" [formGroup]="model" (ngSubmit)="submit()">
      <div class="body-confirm-modal-list">
        <mat-form-field appearance="outline">
          <mat-label>Leito</mat-label>
          <mat-select #bed formControlName="idBed" (selectionChange)="checkHygienization($event)">
            @if (selectedBed && hygienization) {
              <mat-select-trigger>
                {{selectedBed.bedName}}
                @if (selectedBed.idHygienizationStatus == hygienizedStatus && hygienization) {
                  <div class="bullet" [style.background-color]="'#045bbf'"
                    matTooltip="Higienizado">
                  </div>
                }
                @if (selectedBed.idHygienizationStatus == unhygienizedStatus && hygienization) {
                  <div class="bullet" [style.background-color]="'#db1f67'"
                    matTooltip="Não higienizado">
                  </div>
                }
                @if (selectedBed.idHygienizationStatus == hygienizingStatus && hygienization) {
                  <div class="bullet" [style.background-color]="'#e89323'"
                    matTooltip="Em higienização">
                  </div>
                }
              </mat-select-trigger>
            }
            @for (item of listFreeBed; track item) {
              <mat-option [style.display]="'block'" [value]="item.idBed">
                <span>
                  {{item.bedName}}
                </span>
                @if (item.idHygienizationStatus == hygienizedStatus && hygienization) {
                  <div class="bullet" [style.background-color]="'#045bbf'"
                    matTooltip="Higienizado">
                  </div>
                }
                @if (item.idHygienizationStatus == unhygienizedStatus && hygienization) {
                  <div class="bullet" [style.background-color]="'#db1f67'"
                    matTooltip="Não higienizado">
                  </div>
                }
                @if (item.idHygienizationStatus == hygienizingStatus && hygienization) {
                  <div class="bullet" [style.background-color]="'#e89323'"
                    matTooltip="Em higienização">
                  </div>
                }
              </mat-option>
            }
          </mat-select>
          <!-- <mat-error *ngIf="model.get('idBed').invalid">Informe o leito</mat-error> -->
        </mat-form-field>
        @if (unhygienizedAllocationConfirm || oldStatusHygienization != null) {
          <mat-slide-toggle formControlName="unhygienizedAllocation"
            [checked]="unhygienizedAllocationConfirm" (change)="toggleConfirmation($event)">
            <span>
              Eu confirmo que o leito foi higienizado antes da alocação
            </span>
          </mat-slide-toggle>
        }
      </div>
      <div class="footer-confirm-modal-list">
        @if (isMedicAllocateBed) {
          <button mat-flat-button color="primary" class="btn-block"
            [disabled]="!model.valid" (click)="isMedicAllocated()">
            @if (isLoading == false) {
              <span>Confirmar</span>
            }
            @if (isLoading == true) {
              <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
            }
          </button>
        }
        @if (isMedicAllocateBed) {
          <button type="button" mat-flat-button color="accent" class="btn-block"
          (click)="isMedicNoAllocated()">Cancelar</button>
        }

        @if (!isMedicAllocateBed) {
          <button mat-flat-button color="primary" class="btn-block" type="submit"
            [disabled]="!model.valid">
            @if (isLoading == false) {
              <span>Atender</span>
            }
            @if (isLoading == true) {
              <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
            }
          </button>
        }
        @if (!isMedicAllocateBed) {
          <button type="button" mat-flat-button color="accent" class="btn-block"
          (click)="clickCancel()">Cancelar</button>
        }
      </div>
    </form>
  </div>
</div>